<template>
  <div id="deptManage">
    <el-form :inline="true" :model="searchForm">
      <el-form-item label="省市区">
        <el-cascader
          clearable
          size="mini"
          style="width: 250px"
          v-model="searchForm.provinceAndCityAndCounty"
          :options="provinceAndCityAndCountyOption"
        ></el-cascader>
      </el-form-item>
      <el-form-item>
        <el-input
          size="mini"
          placeholder="搜索关键字"
          prefix-icon="el-icon-search"
          v-model="searchForm.keyWords"
        >
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="onSearch">查询</el-button>
        <el-button type="primary" size="mini" @click="onCreate"
          >创建部门</el-button
        >
      </el-form-item>
    </el-form>
    <el-table max-height="500px" :data="tableData" style="width: 100%">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column type="index" label="NO"></el-table-column>
      <el-table-column prop="deptName" label="部门名称"></el-table-column>
      <el-table-column
        prop="province"
        label="省份"
        :formatter="codeToText"
      ></el-table-column>
      <el-table-column
        prop="city"
        label="市区"
        :formatter="codeToText"
      ></el-table-column>
      <el-table-column prop="principal" label="负责人"></el-table-column>
      <el-table-column
        prop="createTime"
        :formatter="dateFormatter"
        label="创建日期"
      ></el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="viewDept(scope.row)"
            type="text"
            size="small"
          >
            修改
          </el-button>
          <el-button
            @click.native.prevent="deleteDept(scope.row)"
            type="text"
            size="small"
          >
            删除
          </el-button>
          <!--<el-button-->
          <!--@click.native.prevent="uploadLogo(scope.row)"-->
          <!--type="text"-->
          <!--size="small">-->
          <!--{{scope.row.logo ? "修改" : "上传"}}LOGO-->
          <!--</el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.currentPage"
        :page-sizes="[10, 20, 30]"
        :page-size="pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageInfo.total"
      >
      </el-pagination>
    </div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="70%"
      @closed="handleClose"
    >
      <el-form
        ref="deptForm"
        :model="deptForm"
        :rules="rules"
        label-width="120px"
        style="padding: 0 40px 0 0"
      >
        <el-form-item label="名称" prop="deptName">
          <el-input v-model="deptForm.deptName"></el-input>
        </el-form-item>
        <el-form-item label="图片">
          <!--<img style="width: 40px;" :src="logoImg ? '/api/'+logoImg : require('../assets/image.png')">-->
          <el-upload
            ref="upload"
            action="/api/sysConfig/upload"
            list-type="picture-card"
            :limit="1"
            :on-success="uploadIconSuccess"
            :file-list="logoFile"
          >
            <i class="el-icon-plus icon-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="介绍">
          <ueditor v-model="deptForm.introduce"></ueditor>
          <!-- <el-input
            type="textarea"
            :rows="2"
            v-model="deptForm.introduce"
          ></el-input> -->
        </el-form-item>
        <el-form-item label="联系人" >
          <el-input v-model="deptForm.principal"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model.number="deptForm.tel"></el-input>
        </el-form-item>
        <el-form-item label="省市区">
          <el-cascader
            clearable
            style="width: 100%"
            v-model="deptForm.provinceAndCityAndCounty"
            :options="provinceAndCityAndCountyOption"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址">
          <el-input v-model="deptForm.addressDetail"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
    <!--<el-dialog-->
    <!--title="上传LOGO"-->
    <!--:visible.sync="uploadLogoVisible"-->
    <!--width="40%"-->
    <!--:before-close="handleLogoClose">-->
    <!--<el-upload-->
    <!--ref="upload"-->
    <!--action=""-->
    <!--class="icon-uploader"-->
    <!--:on-change="handleLogoSuccess"-->
    <!--:auto-upload="false"-->
    <!--:show-file-list="false">-->
    <!--<img v-if="logoImg" :src="logoImg" class="icon-img">-->
    <!--<i v-else class="el-icon-plus icon-uploader-icon"></i>-->
    <!--</el-upload>-->
    <!--<span slot="footer" class="dialog-footer">-->
    <!--<el-button @click="handleLogoClose">取 消</el-button>-->
    <!--<el-button type="primary" @click="onLogoFileSubmit">确 定</el-button>-->
    <!--</span>-->
    <!--</el-dialog>-->
  </div>
</template>

<script>
import { CodeToText, regionDataPlus } from "element-china-area-data";
import axios from "axios";
import utils from "../utils/utils";
import ueditor from './plugin/my-editor-ueditor.vue'
export default {
  components:{ueditor},
  name: "dept-manage",
  data() {
    return {
      provinceAndCityAndCountyOption: regionDataPlus,
      searchForm: {
        provinceAndCityAndCounty: [],
        keyWords: "",
      },
      tableData: [],
      pageInfo: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      dialogTitle: "",
      dialogVisible: false,
      deptForm: {
        deptName: "",
        introduce: "",
        provinceAndCityAndCounty: [],
        addressDetail: "",
        principal: "",
        tel: "",
      },
      rules: {
        deptName: [
          { required: true, message: "请输入部门名称", trigger: "blur" },
          {
            min: 1,
            max: 30,
            message: "长度在 1 到 30 个字符",
            trigger: "blur",
          },
        ],
        introduce: [
          { required: true, message: "请输入部门简介", trigger: "blur" },{ min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        provinceAndCityAndCounty: [
          { required: true, message: "请选择省市区", trigger: "change" ,validator:(rule,value,callback)=>{
            console.log(value)
            if(!value || value.length==0){
              return callback(new Error('请选择省市区'));
            } 
            if(!value.some(item=> item && item!=''&& item!=null)){
              return callback(new Error('请选择省市区'));
            }
            callback();
          }},
        ],
        addressDetail: [
          { required: true, message: "请输入详细地址", trigger: "blur" },{ min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        principal: [
          { required: true, message: "请输入负责人", trigger: "blur" },{ min: 1, max: 10, message: "长度在 1 到 10 个字符", trigger: "blur" }
        ],
        tel: [{ required: true, message: "请输入联系电话", trigger: "blur" },
        {pattern: /^[123456789]\d{7,10}$/, message: "请输入正确的联系电话", trigger: "blur" }],
      },
      deptId: null,
      uploadLogoVisible: false,
      logoFile: [],
      logoImg: "",
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0)",
      });
      let success = (response) => {
        loading.close();
        if (response.data.code === 0) {
          this.pageInfo.total = response.data.total;
          this.tableData = response.data.list;
        }
      };
      utils.axiosMethods({
        method: "POST",
        url: "/api/accountManage/queryDeptB",
        params: {
          currentPage: this.pageInfo.currentPage,
          pageSize: this.pageInfo.pageSize,
        },
        data: {
          province: this.searchForm.provinceAndCityAndCounty
            ? this.searchForm.provinceAndCityAndCounty[0]
            : "",
          city: this.searchForm.provinceAndCityAndCounty
            ? this.searchForm.provinceAndCityAndCounty[1]
            : "",
          county: this.searchForm.provinceAndCityAndCounty
            ? this.searchForm.provinceAndCityAndCounty[2]
            : "",
          keyWords: this.searchForm.keyWords,
        },
        callback: success,
        catch: (err) => {
          loading.close();
        },
      });
    },
    onSearch() {
      this.getData();
    },
    onCreate() {
      this.dialogVisible = true;
      this.dialogTitle = "创建部门";
      this.action = "add";
    },
    viewDept(row) {
      this.dialogVisible = true;
      this.dialogTitle = "编辑部门";
      this.action = "update";
      this.deptForm = {
        deptName: row.deptName,
        introduce: row.introduce,
        provinceAndCityAndCounty: [row.province, row.city, row.county],
        addressDetail: row.addressDetail,
        principal: row.principal,
        tel: row.tel,
      };
      this.deptId = row.id;
      if (row.logo && row.logo.length > 0) {
        this.logoFile = [
          {
            url: row.logo,
          },
        ];
      }
    },
    deleteDept(row) {
      utils.axiosMethods({
        method: "GET",
        url: "/api/accountManage/deleteDeptB",
        params: {
          id: row.id,
        },
        callback: (res) => {
          this.$message.success("删除成功");
          this.getData();
        },
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.deptForm = {
        deptName: "",
        introduce: "",
        provinceAndCityAndCounty: [],
        addressDetail: "",
        principal: "",
        tel: "",
      };
      this.deptId = null;
      this.logoImg = "";
      this.logoFile = [];
       this.$refs["deptForm"].resetFields();
    },
    submitForm() {
      //验证表单
      this.$refs["deptForm"].validate((valid) => {
        if (valid) {
          let url, formData;
          formData = {
            deptName: this.deptForm.deptName,
            introduce: this.deptForm.introduce,
            province: this.deptForm.provinceAndCityAndCounty[0],
            city: this.deptForm.provinceAndCityAndCounty[1],
            county: this.deptForm.provinceAndCityAndCounty[2],
            addressDetail: this.deptForm.addressDetail,
            principal: this.deptForm.principal,
            tel: this.deptForm.tel,
            logo: this.logoImg,
          };
          if (this.action == "add") {
            url = "/api/accountManage/insertDeptB";
          } else {
            url = "/api/accountManage/updateDeptB";
            formData.id = this.deptId;
          }
          utils.axiosMethods({
            method: "POST",
            url: url,
            data: formData,
            callback: (res) => {
              this.dialogVisible = false;
              if (this.action == "add") {
                this.$message.success("创建成功");
              } else {
                this.$message.success("修改成功");
              }
              this.getData();
            },
          });
        }
      });
    },
    //每页展示数据条数改变
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getData();
    },
    //页码改变
    handleCurrentChange(val) {
      this.pageInfo.currentPage = val;
      this.getData();
    },
    // 日期格式化
    dateFormatter(row, column, cellValue, index) {
      return utils.dateFormat(cellValue);
    },
    // 省市显示中文
    codeToText(row, column, cellValue, index) {
      return CodeToText[cellValue];
    },
    uploadLogo(row) {
      this.uploadLogoVisible = true;
      this.deptId = row.id;
      this.logoImg = row.logo ? "/api/" + row.logo : "";
    },
    // handleLogoClose(){
    //   this.uploadLogoVisible = false
    //   this.logoImg = ""
    //   this.logoFile = null
    //   this.deptId = null
    // },
    // handleLogoSuccess(file, fileList){
    //   this.logoImg = URL.createObjectURL(file.raw);
    //   this.logoFile = file.raw;
    // },
    onLogoFileSubmit() {
      let formData = new FormData();
      // formData.append("file", this.logoFile);
      formData.append("id", this.deptId);
      axios
        .post("/api/accountManage/uploadDeptLogo", formData)
        .then((response) => {
          if (response.data.code == 0) {
            this.handleLogoClose();
            this.$message({
              message: "LOGO上传成功",
              type: "success",
            });
            this.getData();
          } else {
            this.$message({
              message: response.data.msg,
              type: "error",
            });
          }
        })
        .catch((error) => {
          this.$message({
            message: error,
            type: "error",
          });
        });
    },
    uploadIconSuccess(response, file, fileList) {
      let logoImg = [];
      fileList.forEach((item) => {
        logoImg.push(item.response);
      });
      this.logoImg = logoImg.join(";");
    },
    removeIcon(file, fileList) {
      this.logoImg = "";
      // 删除原有图片
      utils.axiosMethods({
        method: "POST",
        url: "/upload/sysConfig/deletefile",
        params: {
          url: file.response ? file.response : file.url,
        },
      });
    },
  },
};
</script>

<style scoped lang="less">
#deptManage {
  .block {
    float: right;
    margin-top: 20px;
  }
}
</style>
<style lang="less">
#deptManage {
  .icon-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .icon-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .icon-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
  .icon-img {
    width: 60px;
    height: 60px;
    display: block;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/deptManage.vue